// Nhớ (trong tab, qua F5) bot nào vừa được ra lệnh "đọc lại nhóm" để không gửi lệnh thứ hai khi máy chủ chắc chắn trả 409 "đang đọc" (xem src/shared/nhom-nick.ts).
import { dangDocNhom, ghiLenhDocLai, type LenhDocLai } from "../../../src/shared/nhom-nick";

const KHOA = "nhom-nick-doc-lai";
function doc(): LenhDocLai {
  try { const v = JSON.parse(sessionStorage.getItem(KHOA) ?? "{}") as unknown; return v && typeof v === "object" && !Array.isArray(v) ? (v as LenhDocLai) : {}; } catch { return {}; }
}
/** Bot này vừa được ra lệnh đọc lại trong vài phút qua (tab này)? */
export const conDangDocNhom = (botId: string, now = Date.now()): boolean => dangDocNhom(doc(), botId, now);
/** Ghi nhận đã ra lệnh (hoặc máy chủ báo đang đọc) cho bot này. */
export function ghiDaRaLenhDocLai(botId: string, now = Date.now()): void {
  try { sessionStorage.setItem(KHOA, JSON.stringify(ghiLenhDocLai(doc(), botId, now))); } catch { /* tab riêng tư / bị chặn: chỉ mất phần nhớ, không hỏng chức năng */ }
}
